export function threadsSearchListEmpty({ loading, hasThreads }) {
  if (loading) return 'Loading threads…'
  if (hasThreads) return 'No matching threads.'
  return 'Start conversation to see your History here'
}
